import { InjectionToken } from '@angular/core';

import { environment } from '../../../environments/environment';

export const CONFIG_URL = new InjectionToken<string>('CONFIG_URL', {
    providedIn: 'root',
    factory: () => environment.configUrl,
});

export const BASE_URL = new InjectionToken<string>('BASE_URL');
export const API_KEY = new InjectionToken<string>('API_KEY');
export const FINGER_PRINT_API_KEY = new InjectionToken<Promise<string>>('FINGER_PRINT_API_KEY');
export const APP_DOCUMENTATION_BASE_URL = new InjectionToken<Promise<string>>('APP_DOCUMENTATION_BASE_URL');
export const AUTH_BASE_URL = new InjectionToken<Promise<string>>('AUTH_BASE_URL');
export const X_FUNCTIONS_KEY = new InjectionToken<Promise<string>>('X_FUNCTIONS_KEY');

export const APP_VERSION = new InjectionToken<string>('APP_VERSION', {
    providedIn: 'root',
    factory: () => environment.appVersion,
});

export const IndexDBName = 'SALSurveyDB';
export const IS_PRODUCTION = environment.production;
